function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
  
function getCookieCustom(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
          c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
      }
  }
  return "";
}
$(document).ready(function () {
  setCookie('ppviewtimer', false, 0);
    var e = $(".announcement-bar").height(),
        n = "store_notice";
    "hidden" === getCookieCustom(n)
        ? ($(".announcement-bar").hide(), $("header").css("margin-top", 0), $("body").css("padding-top", 0))
        : ($(".announcement-bar").show(), $("header").css("margin-top", e), $("body").css("padding-top", e)),
        $(".store-notice__dismiss-link").click(function (e) {
            (function (e, n, s) {
                var t = new Date();
                t.setTime(t.getTime() + 24 * s * 60 * 60 * 1e3);
                var i = "expires=" + t.toUTCString();
                document.cookie = e + "=" + n + ";" + i + ";path=/";
            })(n, "hidden", { path: "/" }),
                $(".announcement-bar").hide(),
                e.preventDefault(),
                $("header").css("margin-top", 0),
                $("body").css("padding-top", 0);
        }),
        $(".home_shop_slide").slick({
            dots: !1,
            infinite: !0,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: !0,
            arrows: !0,
            responsive: [
                { breakpoint: 800, settings: { slidesToShow: 1, slidesToScroll: 1, centerMode: !0, centerPadding: "170px" } },
                { breakpoint: 767, settings: { slidesToShow: 1, slidesToScroll: 1, centerMode: !0, centerPadding: "70px" } },
                { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
            ],
        }),
        $(".insta_slider").slick({
            dots: !1,
            infinite: !1,
            slidesToShow: 4,
            slidesToScroll: 1,
            autoplay: !1,
            arrows: !1,
            responsive: [
                { breakpoint: 640, settings: { slidesToShow: 2, slidesToScroll: 1 } },
                { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
            ],
        }),
        $(".et_pb_video_overlay").click(function () {
            ($(this).siblings(".et_pb_video_box").find("iframe")[0].src += "&autoplay=1"), $(this).hide();
        }),
        $(".Faq_slider").slick({
            dots: !1,
            infinite: !0,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: !1,
            prevArrow: $(".glide__arrow--left"),
            nextArrow: $(".glide__arrow--right"),
            responsive: [
                { breakpoint: 981, settings: { slidesToShow: 3, slidesToScroll: 1 } },
                { breakpoint: 801, settings: { slidesToShow: 1, slidesToScroll: 1, centerMode: !0, infinite: !0, centerPadding: "190px" } },
                { breakpoint: 601, settings: { slidesToShow: 1, slidesToScroll: 1, centerMode: !0, infinite: !0, centerPadding: "90px" } },
                { breakpoint: 481, settings: { slidesToShow: 1, slidesToScroll: 1, centerMode: !1, infinite: !1 } },
            ],
        }),
        $(".strength select").change(function () {
            $(".pro_short_des").removeClass("show_des"), "" != $(this).val() ? $("." + $(this).val()).addClass("show_des") : $(".default_des").addClass("show_des");
        }),
        $("document").ready(function () {}),
        $(".faqs .question").length > 0 &&
            ($("article .answer").hide(),
            $(".faqs .question").click(function () {
                var e = $(this),
                    n = e.closest(".faq").length > 0 ? e.closest(".faq") : e.parent();
                n.toggleClass("show"), n.hasClass("show") ? e.closest(".faq").find(".answer").show(1e3) : e.closest(".faq").find(".answer").hide(1e3);
            })),
        $(".stories_nav .og-tab-nav .btn").click(function () {
            var e = $(this).attr("data-tabnum");
            $([document.documentElement, document.body]).animate({ scrollTop: $("#" + e).offset().top - 100 }, 2e3);
        }),
        $(document).on("click", ".description_tab", function () {
            $(this).addClass("active"), $(this).siblings("li").removeClass("active");
            var e = $(this).data("tab");
            return $(".tab-description").hide(), $(e).fadeIn(), !1;
        }),
        $('input[type="password"]').wrap('<span class="password-input"></span>'),
        $(".password-input").append('<span class="show-password-input"></span>'),
        $(".show-password-input").click(function () {
            $(this).toggleClass("display-password"), $(this).hasClass("display-password") ? $(this).siblings(['input[name="password"]', 'input[type="password"]']).prop("type", "text") : $(this).siblings("input").prop("type", "password");
        }),
        $("button.mobile-nav__link").click(function () {
            $(this).siblings(".mobile-nav__dropdown").hasClass("mobilemenu_open")
                ? ($(this).siblings(".mobile-nav__dropdown").removeClass("mobilemenu_open"), (window.location.href = $(this).data("href")))
                : $(this).siblings(".mobile-nav__dropdown").addClass("mobilemenu_open").slideDown();
        }),
        $(document).on("click", ".check_btn", function () {
            window.location = "/checkout";
        });
});
var $animation_elements = $(".et_pb_animation_top"),
    $window = $(window);
function check_if_in_view() {
    var e = $window.height(),
        n = $window.scrollTop(),
        s = n + e;
    $.each($animation_elements, function () {
        var e = $(this),
            t = e.outerHeight(),
            i = e.offset().top;
        i + t >= n && i <= s && e.addClass("et-animated");
    });
}
$window.on("scroll resize", check_if_in_view),
    $window.trigger("scroll"),
    $(document).ready(function () {
        var e = $(".announcement-bar").height(),
            n = "store_notice";
        "hidden" ===
        (function (e) {
            for (var n = e + "=", s = decodeURIComponent(document.cookie).split(";"), t = 0; t < s.length; t++) {
                for (var i = s[t]; " " == i.charAt(0); ) i = i.substring(1);
                if (0 == i.indexOf(n)) return i.substring(n.length, i.length);
            }
            return "";
        })(n)
            ? ($(".announcement-bar").hide(), $("header").css("margin-top", 0))
            : ($(".announcement-bar").show(), $("header").css("margin-top", e)),
            $(".store-notice__dismiss-link").click(function (e) {
                (function (e, n, s) {
                    var t = new Date();
                    t.setTime(t.getTime() + 24 * s * 60 * 60 * 1e3);
                    var i = "expires=" + t.toUTCString();
                    document.cookie = e + "=" + n + ";" + i + ";path=/";
                })(n, "hidden", { path: "/" }),
                    $(".announcement-bar").hide(),
                    e.preventDefault(),
                    $("header").css("padding-top", 0);
            }),
            $(".og-tab-nav button").click(function () {
                $(this).addClass("tab-active"), $(this).siblings("button").removeClass("tab-active");
                var e = $(this).attr("data-tabnum");
                $(".tab_content").hide(), $("#" + e).fadeIn();
                tab_content = document.querySelector("#" + e);
                slide = (parseFloat(getComputedStyle(tab_content.querySelector(".products")).columnGap) + parseFloat(getComputedStyle(tab_content.querySelector(".product")).width)).toFixed(0);
                currentScroll = tab_content.querySelector(".content").scrollLeft;
                console.log(currentScroll);
                if (currentScroll <= 180 && tab_content.querySelector(".content").getBoundingClientRect().width < tab_content.querySelector(".products").getBoundingClientRect().width) {
                    tab_content.querySelector(".arrow-control.arrow-right").classList.remove("hide");
                } else if (tab_content.querySelector(".products") && tab_content.querySelector(".content").getBoundingClientRect().width <= tab_content.querySelector(".products").getBoundingClientRect().width - (currentScroll + slide)) {
                    tab_content.querySelector(".arrow-control.arrow-right").classList.remove("hide");
                } else if (currentScroll >= slide) {
                    tab_content.querySelector(".arrow-control.arrow-left").classList.remove("hide");
                }
            });
    }),
    $(window).scroll(function () {
        $(window).scrollTop() > 10 ? $("header").addClass("sticky_header") : $("header").removeClass("sticky_header");
    }),
    $(document).ready(function () {
        var e = $(location).attr("href").split("?");
        if (null != e[1]) {
            var n = e[1].split("=");
            if (" " != n || null != n) {
                var s = $("." + n[0] + " select")
                    .find('option[data-value="' + n[1].toLowerCase() + '"]')
                    .val();
                $("." + n[0] + " select").val(s);
            }
            $(".strength select").length > 0 && $(".strength select").trigger("change");
        }
    });

$(document).ready(function(){ 
  $(document).on('change','.single-option-selector',function(e){
    e.preventDefault();
    if(('#rc_container').length > 1){
      var RechargeVal = $('.product-form__variants option:selected').attr('data-recharge');
      if(RechargeVal == '1' || RechargeVal == 1){
        $('#rc_container').addClass('hidden');
        $('#rc_container input[type="radio"].rc_radio__onetime').trigger('click');
      }else{
        $('#rc_container').removeClass('hidden')
      }
    }
  });
  $('.single-option-selector').trigger('change');
});

function beforeDiscountRedemption() {
  var redeemedItemsInCart = 0;
  var regularItemsInCart = 0;
  var discountInCart = 0;
  if (Swell.Cart && Swell.Cart.items) {
    var cart = Swell.Cart;
    $.each(cart.items, function (index, item) {
      if (item.properties._swell_points_used) {
        redeemedItemsInCart++;
      } 
      else if (item.line_price > 0) {
        regularItemsInCart++;
      }
    });
    Swell.Cart.items.forEach(function (item) {
      if (item.properties._swell_discount_type == "cart_fixed_amount") {
        discountInCart++;
      }
    });
    if (discountInCart > 0) {
      spapi.$.confirm({
        title: "Oops!",
        content: "You already have a redeemed discount in your cart.",
        type: "red",
        typeAnimated: true,
        useBootstrap: false,
        boxWidth: "400px",
        buttons: {
          ok: {
            text: "Ok",
            action: function () {}
          }
        }
      });
      return false;
    } 
    else if (regularItemsInCart == 0) {
      spapi.$.confirm({
        title: "Oops!",
        content: "You must add a priced item in your cart to redeem points for a discount.",
        type: "red",
        typeAnimated: true,
        useBootstrap: false,
        boxWidth: "400px",
        buttons: {
          ok: {
            text: "Ok",
            action: function () {}
          }
        }
      });
      return false;
    } 
    else {
      return true;
    }
  }
};

$(document).ready(function () {
  $(document).on("swell:setup", function () {
    if (spapi.authenticated) {

      var redemption_option = spapi.activeRedemptionOptions;
      redemption_option.forEach(function (redemption) {
        if (redemption.discount_type == "cart_fixed_amount") {
          $('.swell_dropdown').append('<option value="'+redemption.id  +'">'+ redemption.name +'</option>');
          // populate the redemption options in dropdown. Value will be the id of the coupon(redemption.id)
        }
      });
      if (window.location.href.indexOf("cart") == -1) {
        const targetNode = document.getElementById('cart_container_id');
        // Options for the observer (which mutations to observe)
        const config = { attributes: true, childList: true, subtree: true };
        // Callback function to execute when mutations are observed
        const callback = function(mutationsList, observer) {
          if($(".swell-discount-coupon").length == 0) {
            Swell.Cart.items.forEach(function (item) {
              if (item.properties._swell_discount_type == "cart_fixed_amount") {
                redeemedRedemptionOption = swellAPI.findActiveRedemptionOptionById(item.properties._swell_redemption_option_id);
                $(".cart-middle-items .cart-container").append('<div class="items_row CartItem swell-discount-coupon"> <div class="cart-left"><a class="cart-image" style=" display: flex; align-items: center; justify-content: center">'+ redeemedRedemptionOption.name +'</a></div> <div class="cart-right"> <div class="cart-title"> <a>'+ redeemedRedemptionOption.name +'</a> <span class="ajaxcart__product-meta">Discount</span> </div> <div class="cart-price"><span class="money">'+ redeemedRedemptionOption.cost_text +'</span></div> <ul class="QuantityBox cart_p_quantity"> <li class="minus-box"></li> <li class="input-box"><input disabled type="text" class="QuantityInput Quantity_cart_slider ajaxcart__qty-num" value="1" style="background: #ffffff;"></li> <li class="plus-box"></li> </ul> <span class="cart_remove_item swell-coupon-remove"> <svg viewBox="0 0 438.529 438.529" class="icon icon-delete"> <path d="M417.689,75.654c-1.711-1.709-3.901-2.568-6.563-2.568h-88.224L302.917,25.41c-2.854-7.044-7.994-13.04-15.413-17.989 C280.078,2.473,272.556,0,264.945,0h-91.363c-7.611,0-15.131,2.473-22.554,7.421c-7.424,4.949-12.563,10.944-15.419,17.989 l-19.985,47.676h-88.22c-2.667,0-4.853,0.859-6.567,2.568c-1.709,1.713-2.568,3.903-2.568,6.567v18.274 c0,2.664,0.855,4.854,2.568,6.564c1.714,1.712,3.904,2.568,6.567,2.568h27.406v271.8c0,15.803,4.473,29.266,13.418,40.398 c8.947,11.139,19.701,16.703,32.264,16.703h237.542c12.566,0,23.319-5.756,32.265-17.268c8.945-11.52,13.415-25.174,13.415-40.971 V109.627h27.411c2.662,0,4.853-0.856,6.563-2.568c1.708-1.709,2.57-3.9,2.57-6.564V82.221 C420.26,79.557,419.397,77.367,417.689,75.654z M169.301,39.678c1.331-1.712,2.95-2.762,4.853-3.14h90.504 c1.903,0.381,3.525,1.43,4.854,3.14l13.709,33.404H155.311L169.301,39.678z M347.173,380.291c0,4.186-0.664,8.042-1.999,11.561 c-1.334,3.518-2.717,6.088-4.141,7.706c-1.431,1.622-2.423,2.427-2.998,2.427H100.493c-0.571,0-1.565-0.805-2.996-2.427  c-1.429-1.618-2.81-4.188-4.143-7.706c-1.331-3.519-1.997-7.379-1.997-11.561V109.627h255.815V380.291z" vector-effect="non-scaling-stroke"></path> <path d="M137.04,347.172h18.271c2.667,0,4.858-0.855,6.567-2.567c1.709-1.718,2.568-3.901,2.568-6.57V173.581 c0-2.663-0.859-4.853-2.568-6.567c-1.714-1.709-3.899-2.565-6.567-2.565H137.04c-2.667,0-4.854,0.855-6.567,2.565 c-1.711,1.714-2.568,3.904-2.568,6.567v164.454c0,2.669,0.854,4.853,2.568,6.57C132.186,346.316,134.373,347.172,137.04,347.172z" vector-effect="non-scaling-stroke"></path> <path d="M210.129,347.172h18.271c2.666,0,4.856-0.855,6.564-2.567c1.718-1.718,2.569-3.901,2.569-6.57V173.581 c0-2.663-0.852-4.853-2.569-6.567c-1.708-1.709-3.898-2.565-6.564-2.565h-18.271c-2.664,0-4.854,0.855-6.567,2.565 c-1.714,1.714-2.568,3.904-2.568,6.567v164.454c0,2.669,0.854,4.853,2.568,6.57C205.274,346.316,207.465,347.172,210.129,347.172z" vector-effect="non-scaling-stroke"></path> <path d="M283.22,347.172h18.268c2.669,0,4.859-0.855,6.57-2.567c1.711-1.718,2.562-3.901,2.562-6.57V173.581 c0-2.663-0.852-4.853-2.562-6.567c-1.711-1.709-3.901-2.565-6.57-2.565H283.22c-2.67,0-4.853,0.855-6.571,2.565 c-1.711,1.714-2.566,3.904-2.566,6.567v164.454c0,2.669,0.855,4.853,2.566,6.57C278.367,346.316,280.55,347.172,283.22,347.172z" vector-effect="non-scaling-stroke"></path> </svg> </span> </div> </div>')
                return
              }
            });
          }
          if($(".swell_dropdown option").length < 2) {
            var redemption_option = spapi.activeRedemptionOptions;
            redemption_option.forEach(function (redemption) {
              if (redemption.discount_type == "cart_fixed_amount") {
                $('.swell_dropdown').append('<option value="'+redemption.id  +'">'+ redemption.name +'</option>');
                // populate the redemption options in dropdown. Value will be the id of the coupon(redemption.id)
              }
            });
          }
        };
        // Create an observer instance linked to the callback function
        const observer = new MutationObserver(callback);
         // Start observing the target node for configured mutations
        observer.observe(targetNode, config);
      }
      $('body').on('click', '#swell_redeem_btn', function () {
        if (spapi.authenticated) {
          Swell.Cart.getCart(function () {
          if (beforeDiscountRedemption()) {
            redemptionOptionId = $(".swell_dropdown").val();
            redemptionOption = swellAPI.findActiveRedemptionOptionById(redemptionOptionId);
            swellAPI.refreshCustomerDetails();
            $(document).on("swell:cart:updated", function () {
              window.location = window.location;
            });
            if (redemptionOption.amount <= spapi.customer.adjusted_points_balance) {
              result = swellAPI.buyMultipleWithPoints([redemptionOption], function () {});
            } 
            else {
              spapi.$.confirm({
                title: "Oops!",
                content: "You don't have enough points!",
                type: "red",
                typeAnimated: true,
                useBootstrap: false,
                boxWidth: "400px",
                buttons: {
                  ok: {
                    text: "Ok",
                    action: function () {}
                  }
                }
              });
            }
          }
          });
        }
      });
      Swell.Cart.items.forEach(function (item) {
        if (item.properties._swell_discount_type == "cart_fixed_amount") {
          redeemedRedemptionOption = swellAPI.findActiveRedemptionOptionById(item.properties._swell_redemption_option_id);
          $(".cart-middle-items .cart-container").append('<div class="items_row CartItem swell-discount-coupon"> <div class="cart-left"><a class="cart-image" style=" display: flex; align-items: center; justify-content: center">'+ redeemedRedemptionOption.name +'</a></div> <div class="cart-right"> <div class="cart-title"> <a>'+ redeemedRedemptionOption.name +'</a> <span class="ajaxcart__product-meta">Discount</span> </div> <div class="cart-price"><span class="money">'+ redeemedRedemptionOption.cost_text +'</span></div> <ul class="QuantityBox cart_p_quantity"> <li class="minus-box"></li> <li class="input-box"><input disabled type="text" class="QuantityInput Quantity_cart_slider ajaxcart__qty-num" value="1" style="background: #ffffff;"></li> <li class="plus-box"></li> </ul> <span class="cart_remove_item swell-coupon-remove"> <svg viewBox="0 0 438.529 438.529" class="icon icon-delete"> <path d="M417.689,75.654c-1.711-1.709-3.901-2.568-6.563-2.568h-88.224L302.917,25.41c-2.854-7.044-7.994-13.04-15.413-17.989 C280.078,2.473,272.556,0,264.945,0h-91.363c-7.611,0-15.131,2.473-22.554,7.421c-7.424,4.949-12.563,10.944-15.419,17.989 l-19.985,47.676h-88.22c-2.667,0-4.853,0.859-6.567,2.568c-1.709,1.713-2.568,3.903-2.568,6.567v18.274 c0,2.664,0.855,4.854,2.568,6.564c1.714,1.712,3.904,2.568,6.567,2.568h27.406v271.8c0,15.803,4.473,29.266,13.418,40.398 c8.947,11.139,19.701,16.703,32.264,16.703h237.542c12.566,0,23.319-5.756,32.265-17.268c8.945-11.52,13.415-25.174,13.415-40.971 V109.627h27.411c2.662,0,4.853-0.856,6.563-2.568c1.708-1.709,2.57-3.9,2.57-6.564V82.221 C420.26,79.557,419.397,77.367,417.689,75.654z M169.301,39.678c1.331-1.712,2.95-2.762,4.853-3.14h90.504 c1.903,0.381,3.525,1.43,4.854,3.14l13.709,33.404H155.311L169.301,39.678z M347.173,380.291c0,4.186-0.664,8.042-1.999,11.561 c-1.334,3.518-2.717,6.088-4.141,7.706c-1.431,1.622-2.423,2.427-2.998,2.427H100.493c-0.571,0-1.565-0.805-2.996-2.427  c-1.429-1.618-2.81-4.188-4.143-7.706c-1.331-3.519-1.997-7.379-1.997-11.561V109.627h255.815V380.291z" vector-effect="non-scaling-stroke"></path> <path d="M137.04,347.172h18.271c2.667,0,4.858-0.855,6.567-2.567c1.709-1.718,2.568-3.901,2.568-6.57V173.581 c0-2.663-0.859-4.853-2.568-6.567c-1.714-1.709-3.899-2.565-6.567-2.565H137.04c-2.667,0-4.854,0.855-6.567,2.565 c-1.711,1.714-2.568,3.904-2.568,6.567v164.454c0,2.669,0.854,4.853,2.568,6.57C132.186,346.316,134.373,347.172,137.04,347.172z" vector-effect="non-scaling-stroke"></path> <path d="M210.129,347.172h18.271c2.666,0,4.856-0.855,6.564-2.567c1.718-1.718,2.569-3.901,2.569-6.57V173.581 c0-2.663-0.852-4.853-2.569-6.567c-1.708-1.709-3.898-2.565-6.564-2.565h-18.271c-2.664,0-4.854,0.855-6.567,2.565 c-1.714,1.714-2.568,3.904-2.568,6.567v164.454c0,2.669,0.854,4.853,2.568,6.57C205.274,346.316,207.465,347.172,210.129,347.172z" vector-effect="non-scaling-stroke"></path> <path d="M283.22,347.172h18.268c2.669,0,4.859-0.855,6.57-2.567c1.711-1.718,2.562-3.901,2.562-6.57V173.581 c0-2.663-0.852-4.853-2.562-6.567c-1.711-1.709-3.901-2.565-6.57-2.565H283.22c-2.67,0-4.853,0.855-6.571,2.565 c-1.711,1.714-2.566,3.904-2.566,6.567v164.454c0,2.669,0.855,4.853,2.566,6.57C278.367,346.316,280.55,347.172,283.22,347.172z" vector-effect="non-scaling-stroke"></path> </svg> </span> </div> </div>')
          return
        }
      });
    }
  });
  $('body').on('click', ".swell-coupon-remove", function () {
    $(document).on("swell:cart:updated", function () {
      window.location = window.location;
    });
    swellAPI.removeRedemptionOptionIdFromCart(redeemedRedemptionOption.id, function () {});
  });
}); 


$(window).scroll(function(){
  if($('.membership-nav-section').length > 0){
    if($(window).width() > 749){
      var TopHeight = Number($('.membership-nav-section').position().top);
      if($(window).scrollTop()>TopHeight){
        $(".membership-nav-section").addClass("sticky_nav")
      }else{
        $(".membership-nav-section").removeClass("sticky_nav")
      }
    }
  }
});

$(document).on('click','.membership-nav-btn',function(){

  if($(this).hasClass('active')){
    $(this).removeClass('active');
  }else{
    $(this).addClass('active');
  }

  $('.membership-nav-dropdown').toggle();

});

var url_ = new URL(window.location.href);
var c = url_.searchParams.get("tag");
let id = null;
if(c!="" && document.querySelector('.tab_'+c)){
  document.querySelector(`[data-tabnum="${ document.querySelector('.tab_'+c).id }"]`).click();
}

$(document).ready(function() {
  $( "body" ).on( "click", ".description_tab .product-single__description a", function() {
    let href = $(this).attr("href");
    window.open(href, '_blank');
  });



     $('.rightBox').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      asNavFor: '.boxContainerContentROutine',
      fade: false
    });
     $('.boxContainerContentROutine').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
    vertical: false,
      asNavFor: '.rightBox',
      fade: false
    });
    $(".nextButtonRoutine").on("click",function(){
          $(' .rightBox').slick('slickNext');
    });
    
    $(".previousButtonRoutine").on("click",function(){
          $('.rightBox').slick('slickPrev');
    });

  
    $('.join-slider').owlCarousel({
        loop: true,
        margin: 10,
        nav: true,
        dots: false,
        navText: [
    "<img src='https://cdn.shopify.com/s/files/1/0383/5717/2364/files/circle-left.svg?v=1678471636' alt='Previous Slide' aria-label='Previous Slide'>", 
    "<img src='https://cdn.shopify.com/s/files/1/0383/5717/2364/files/circle-right.svg?v=1678471641' alt='Next Slide' aria-label='Next Slide'>"
],
        responsive: {
            0: {
                items: 3
            },
            1000: {
                items: 3
            }
        }
    });

  //This code is for sections/global-slider.liquid
  $('.sliderContainerGlobelHeading').slick({
        slidesToScroll: 1,
        slidesToShow: 1,
        vertical: false,
        speed: 1000,
        arrows: false,
        dots: false,
        swipe: false,
         fade: true
    
    });


     $('.items1').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: false,
       swipe: false,
    });
     $('.items2').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: false,
       swipe: false,
    });
     $('.items3').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: false,
       swipe: false,
    });
    $('.slider-for').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            autoplay: false,
            speed: 1000,
            fade: true,
            swipe: false,
            responsive: [{
                breakpoint: 767,
                settings: {
                    fade: false
                }
            }]
        });
      $(".nextButton").on("click",function(){
            $('.sliderContainerGlobelHeading, .items1').slick('slickNext');
            $('.sliderContainerGlobelHeading, .items2').slick('slickNext');
            $('.sliderContainerGlobelHeading, .items3').slick('slickNext');
            $('.sliderContainerGlobelHeading, .slider.slider-for').slick('slickNext');
      });
      
      $(".previousButton").on("click",function(){
            $('.sliderContainerGlobelHeading, .items1').slick('slickPrev');
            $('.sliderContainerGlobelHeading, .items2').slick('slickPrev');
            $('.sliderContainerGlobelHeading, .items3').slick('slickPrev');
            $('.sliderContainerGlobelHeading, .slider.slider-for').slick('slickPrev')
      });


    $('.partner-ctm-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        infinite: true,

        responsive: [
            // {
            //     breakpoint: 1191,
            //     settings: {
            //       slidesToShow: 2,

            //     },
            //   },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    arrows: true,
                    prevArrow: '<span class="slick-prev arrow-btn"><img src="https://cdn.shopify.com/s/files/1/0383/5717/2364/files/left.png?v=1678399603"/></span>',
                    nextArrow: '<span class="slick-next arrow-btn"><img src="https://cdn.shopify.com/s/files/1/0383/5717/2364/files/right.png?v=1678399603"/></span>',
                },
            }
        ],
    });

  
    // partners active class on mouse over
    const mainLogo = document.querySelectorAll('.partner-ctm-slider .partner-width img');
    if (mainLogo) {
        if (screen.width > 767) {
            mainLogo.forEach(logo => {
                logo.addEventListener('mouseover', (e) => {
                    mainLogo.forEach(Mlogo => {
                        Mlogo.closest('.partner-width').classList.remove('active');
                    })
                    e.target.closest('.partner-width').classList.add('active');
                })
            });
        }
    
    
    }


  $('.colection-blogs-slider').slick({
      slidesToScroll: 1,
      slidesToShow: 3,
      arrows: true,
      prevArrow: '<span class="slick-prev arrow-btn"><img src="https://cdn.shopify.com/s/files/1/0383/5717/2364/files/circle-left.svg?v=1678399603"/></span>',
      nextArrow: '<span class="slick-next arrow-btn"><img src="https://cdn.shopify.com/s/files/1/0383/5717/2364/files/circle-right.svg?v=1678399603"/></span>',
      responsive: [{
              breakpoint: 1100,
              settings: {
                  slidesToShow: 2,
              },
          },
  
          , {
              breakpoint: 600,
              settings: {
                  slidesToShow: 1,
              },
          }
      ],
  
  });
});